// extracted by css-extract-rspack-plugin
export default {"body":"Sidesheet-module__body___MMt_J","content":"Sidesheet-module__content___vJJrH","scrollable":"Sidesheet-module__scrollable___NK2af"};